const CLEAN_SUBMIT_FORM_KEY = '.js-clean-submit';

export default class FormHandler {
  static get cleanSubmitForm() {
    return jQuery(CLEAN_SUBMIT_FORM_KEY);
  }

  init() {
    FormHandler.initEmptyFormFieldsCleaner();
  }

  static initEmptyFormFieldsCleaner() {
    FormHandler.cleanSubmitForm.on('submit', (e) => {
      e.preventDefault();

      const form = jQuery(e.target);

      // Remove empty values on form submit, to not include them in URL.
      form
        .find('input, select')
        .filter((index, el) => {
          return !el.value;
        })
        .each((key, el) => {
          el = jQuery(el);

          el.attr('data-original-name', el.attr('name')).attr('name', '');
        });

      // Submit the form.
      form[0].submit();

      // Restore the form, in case page load is cancelled and form is submitted again.
      form.find('[data-original-name]').each((key, el) => {
        el = jQuery(el);

        el.attr('name', el.attr('data-original-name')).removeAttr('data-original-name');
      });
    });
  }
}
